import { render, staticRenderFns } from "./PurchasesList.vue?vue&type=template&id=85521dd8&scoped=true"
import script from "./PurchasesList.vue?vue&type=script&lang=js"
export * from "./PurchasesList.vue?vue&type=script&lang=js"
import style0 from "./PurchasesList.vue?vue&type=style&index=0&id=85521dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85521dd8",
  null
  
)

export default component.exports